/**
 * Toggle Work page modal
 */

const workModal = () => {
  const modalTrigger = document.querySelector('.js-modal-trigger');

  if (modalTrigger) {
    const containers = document.querySelectorAll('.work-clinic__card');

    containers.forEach((container) => {
      container.addEventListener('click', (event) => {
        const modal = (event.currentTarget as Element)?.querySelector('.js-modal');
        const modalCont = (event.currentTarget as Element)?.querySelector('.modal__container');
        const closeBtn = (event.currentTarget as Element)?.querySelector('.modal__close');
        if (modal && !modal.classList.contains('active')) {
          modal.classList.add('active');
          document.body?.classList.add('overflow');
        } else if (!modalCont?.contains(event.target as Node) || closeBtn === event.target) {
          modal?.classList.remove('active');
          document.body?.classList.remove('overflow');
        }
      });
    });
  }
};

export default workModal;
